import React, { Component } from 'react'
import { Link } from 'gatsby'
import netlify from '../../content/images/netlify.png'
import gatsby from '../../content/thumbnails/gatsby.png'
import github from '../../content/images/github.png'

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer container">
        <div>
          <a href="https://github.com/taniarascia" target="_blank" rel="noopener noreferrer">
            Built with Gatsby.js - Theme by Tania Rascia
          </a>
        </div>
        <div>
          <a href="https://instagram.com/rei_yan_">
            /Instagram
          </a>
          <a href="https://www.dicoding.com/users/reiyan">
            Dicoding
          </a>
          <a href="mailto:hariyantoriyan.hr@gmail.com">
            Email/
          </a>
        </div>
      </footer>
    )
  }
}
